import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useAddExamPeriod = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const addExamPeriod = async (examPeriod: any) => {
        try {
            const response = await axios.post("/api/examterms", examPeriod);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.addExamPeriod"));
        }
    }

    return useMutation({ mutationFn: addExamPeriod, onSuccess: (data: any) => {
        queryClient.invalidateQueries({ queryKey: ["examPeriods", data.id] });
        message.success(t("messages.success.addExamPeriod"));
    }});
}